"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationPropTypes = exports.animationDefaultProps = exports.animationCommonPropTypes = exports.animationCommonDefaultProps = exports.isValidAnimationType = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = require("../../constants/propTypes");

var _propTypes4 = require("./Dots/propTypes");

var _propTypes5 = require("./Hourglass/propTypes");

var _propTypes6 = require("./Lock/propTypes");

var _propTypes7 = require("./Windmill/propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isValidAnimationType = exports.isValidAnimationType = _propTypes2.default.oneOf(['', 'dots', 'hourglass', 'lock'] // 'windmill', // under construction
);

var animationCommonDefaultProps = exports.animationCommonDefaultProps = {};

var animationCommonPropTypes = exports.animationCommonPropTypes = _extends({}, _propTypes3.colorPropTypes);

var animationDefaultProps = exports.animationDefaultProps = _extends({}, animationCommonDefaultProps, _propTypes4.dotsDefaultProps, _propTypes5.hourglassDefaultProps, _propTypes6.lockDefaultProps, _propTypes7.windmillDefaultProps);

var animationPropTypes = exports.animationPropTypes = _extends({}, animationCommonPropTypes, _propTypes4.dotsPropTypes, _propTypes5.hourglassPropTypes, _propTypes6.lockPropTypes, _propTypes7.windmillPropTypes, {
  type: isValidAnimationType.isRequired
});